import React from "react";
import { FiShield, FiGlobe, FiTrendingUp, FiClock } from "react-icons/fi";
import  { useRef, useEffect, useState } from "react";

import "./Section.css";

// Images import

import companyIllustration from "../assets/blak.jpg";
import contactImg from "../assets/contct.jpg"



import defenseLogo from "../assets/defense.jpg"
import dojLogo from "../assets/justice.png";
import usafLogo from "../assets/airforce.png";
import doeLogo from "../assets/energy.jpg";
import dlaLogo from "../assets/logistics.png";
import urbanlogo from "../assets/urbn.png";
import security from "../assets/security.png";

import thresure from "../assets/thresure.png";
import unitedd from "../assets/unitedd.png";
import nvy from "../assets/nvy.png";
import stete from "../assets/stete.png";

import {FiCloud, FiCode, FiCpu } from "react-icons/fi";
import girlImg from "../assets/girl.jpg";
import overlayImg from "../assets/2.jpg";



const testimonials = [
  {
    name: "Michael Johnson",
    country: "USA",
    comment:
      "Inframart Solutions delivered scalable and secure solutions that significantly improved our operations.",
  },
  {
    name: "Emma Williams",
    country: "UK",
    comment:
      "Outstanding communication and professionalism throughout the project lifecycle.",
  },
  {
    name: "Daniel Roberts",
    country: "Canada",
    comment:
      "Reliable IT partner with strong technical expertise and timely delivery.",
  },
  {
    name: "Sophia Martinez",
    country: "Spain",
    comment:
      "Their innovative approach helped us streamline processes efficiently.",
  },
  {
    name: "James Anderson",
    country: "Australia",
    comment:
      "One of the most dependable technology service providers we’ve worked with.",
  },
  {
    name: "Oliver Brown",
    country: "Germany",
    comment:
      "Exceptional attention to detail and high-quality software solutions.",
  },
  {
    name: "Isabella Rossi",
    country: "Italy",
    comment:
      "Secure, well-structured, and performance-driven solutions.",
  },
  {
    name: "Ethan Walker",
    country: "USA",
    comment:
      "They clearly understand enterprise-level requirements and deliver results.",
  },
];

const agencies = [
  { logo: defenseLogo },
  {  logo: dojLogo },
  {  logo: usafLogo },
  {  logo: doeLogo },
  { logo: dlaLogo },
   {logo:urbanlogo },
      {logo:security },
        {logo:thresure },
          {logo:unitedd},
            {logo:nvy },
            {logo:stete}
];

const Section = () => {
  const imgRef = useRef(null); const formRef = useRef(null);
   

  useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // jab section viewport mein aaye
          if (entry.target === imgRef.current) {
            entry.target.classList.add("contact-sec-image-visible");
          }
          if (entry.target === formRef.current) {
            entry.target.classList.add("contact-sec-form-visible");
          }
        } else {
          // jab section viewport se bahar jaye (RESET)
          if (entry.target === imgRef.current) {
            entry.target.classList.remove("contact-sec-image-visible");
          }
          if (entry.target === formRef.current) {
            entry.target.classList.remove("contact-sec-form-visible");
          }
        }
      });
    },
    {
      threshold: 0.3, // thora section visible ho tab trigger
    }
  );

  if (imgRef.current) observer.observe(imgRef.current);
  if (formRef.current) observer.observe(formRef.current);

  return () => {
    if (imgRef.current) observer.unobserve(imgRef.current);
    if (formRef.current) observer.unobserve(formRef.current);
  };
}, []);

 

  return (
    <> 
        




        <section className="about-wrapper">
  <div className="about-container">
    {/* LEFT SIDE IMAGES */}
    <div className="about-images">
       

      <img src={girlImg} alt="Girl" className="main-img" />
      <img src={overlayImg} alt="Overlay" className="overlay-img" />
    </div>

    {/* RIGHT SIDE TEXT */}
    <div className="about-text">
      <div className="section-subtitle">
        <div className="line"></div>
        <span>About Our Company</span>
      </div>
      <div className="hi">

      <h1>Are You Ready to Grow Your Business</h1>

      <p>
  In today's fast-paced and ever-evolving business landscape, information technology (IT) services have emerged as a critical driver of success for organizations across industries.
</p>

<p>
  Business landscape, information technology (IT) services have emerged as a critical driver of success for organizations across industries in today's fast-paced and ever-evolving environment.
</p>

<p>
  Our mission is to empower federal agencies and enterprises with innovative technology solutions that streamline operations, protect critical data, and ensure regulatory compliance.
</p>

      <a href="/about" className="learn-more-btn">Learn More</a>
    </div>
    </div>
  </div>
</section>






     <section className="why-choose-wrapper">
      <div className="why-choose-container">
        <h2>Why Choose Inframart Solutions</h2>
        <p className="sub-text">
          Secure, scalable, and trusted IT solutions for global businesses.
        </p>

        <div className="why-choose-grid">
          <div className="why-card">
            <FiShield className="icon" />
            <h4>Secure & Compliant Solutions</h4>
            <p>We ensure data protection using industry-leading security standards.</p>
          </div>

          <div className="why-card">
            <FiGlobe className="icon" />
            <h4>Global Client Experience</h4>
            <p>Serving clients across the USA, UK, Canada, and Europe.</p>
          </div>

          <div className="why-card">
            <FiTrendingUp className="icon" />
            <h4>Scalable & Future-Ready</h4>
            <p>Solutions designed to grow with your business.</p>
          </div>

          <div className="why-card">
            <FiClock className="icon" />
            <h4>On-Time Delivery</h4>
            <p>Committed to meeting deadlines with consistent quality.</p>
          </div>
        </div>
      </div>
    </section>


    


      {/* Your Trusted Partners Section */}
<section className="trusted-partners section">
  <div className="trusted-container">
    {/* Left Side Heading */}
    <div className="trusted-heading">
      <h3>Your Trusted Partners</h3>
      <h2>Highly Motivated Team with Innovative Ideas</h2>
    </div>

    {/* Right Side Paragraph */}
    <div className="trusted-text">
      <p>
        We love what we do and therefore come up with the best possible solutions to help you set and grow online quickly. 
        We are your trusted partners you can count on.
      </p>
    </div>
  </div>

  {/* Images Row */}
  <div className="trusted-images">
    <img src={require("../assets/01.jpg")} alt="Trusted 1" />
    <img src={require("../assets/02.jpg")} alt="Trusted 2" />
    <img src={require("../assets/04.jpg")} alt="Trusted 3" />
    <img src={require("../assets/03.jpg")} alt="Trusted 3" />

    
  </div>
</section>




    
       {/* Trusted Agencies */}
      
    <section className="agencies section">
  <div className="agencies-container">
    {/* LEFT SIDE: Heading + Text */}
    <div className="agencies-text">
      <h2>Trusted by Leading U.S. Government Agencies</h2>

      <p>
        InfraMart Solutions proudly supports some of the nation’s most critical federal missions. Our team ensures that agencies have reliable and secure IT infrastructure to perform their operations efficiently.
      </p>

      <p>
        We specialize in delivering scalable technology solutions that protect sensitive data and maintain compliance with federal regulations. Our services are designed to adapt to the evolving needs of government and enterprise organizations.
      </p>

      <p>
        From cloud computing and cybersecurity to custom software solutions, InfraMart Solutions empowers agencies to achieve their objectives faster and with greater accuracy. Our mission is to simplify complex IT challenges and drive innovation.
      </p>

      <p>
        With a commitment to excellence and reliability, we partner with clients to strengthen mission-critical operations while maintaining the highest standards of security and performance.
      </p>
    </div>

    {/* RIGHT SIDE: Agencies Logos */}
    <div className="agencies-logos">
      <div className="agencies-grid">
        {agencies.map((agency, index) => (
          <div className="agency-card" key={index}>
            <img src={agency.logo} alt={agency.name} />
          </div>
        ))}
      </div>
    </div>
  </div>
</section>

{/* About Us Short Section */}
       <section className="about-home-alt section-alt">
  


  <div className="stats-container">
  <div className="stat-item">
    <div className="stat-label">Years of Experience</div>
    <div className="stat-value">15+</div>
  </div>

  <div className="stat-item">
    <div className="stat-label">Clients Globally</div>
    <div className="stat-value">200+</div>
  </div>

  <div className="stat-item">
    <div className="stat-label">Projects Delivered</div>
    <div className="stat-value">500+</div>
  </div>

  <div className="stat-item">
    <div className="stat-label">Team Members</div>
    <div className="stat-value">150+</div>
  </div>

  <div className="stat-item">
    <div className="stat-label">Countries</div>
    <div className="stat-value">4+</div>
  </div>

  <div className="stat-item">
    <div className="stat-label">Office Locations</div>
    <div className="stat-value">3+</div>
  </div>
</div>

 
</section>
    





<section className="federal-services-wrapper">
  <div className="federal-services-container">
    <h2>Our Core Federal IT Services</h2>
    <p className="federal-services-sub">
      Secure, compliant, and scalable IT solutions tailored for federal agencies.
    </p>

    <div className="federal-services-grid">
      <div className="federal-service-card">
        <div className="federal-icon-box">
          <FiShield />
        </div>
        <h4>Cybersecurity Solutions</h4>
        <p>
          Enterprise-grade security ensuring federal compliance and data protection.
        </p>
        <a href="/services" className="federal-service-link">Learn More</a>
      </div>

      <div className="federal-service-card">
        <div className="federal-icon-box">
          <FiCloud />
        </div>
        <h4>Cloud & Infrastructure</h4>
        <p>
          Scalable, secure, and compliant cloud infrastructure for government agencies.
        </p>
        <a href="/services" className="federal-service-link">Learn More</a>
      </div>

      <div className="federal-service-card">
        <div className="federal-icon-box">
          <FiCode />
        </div>
        <h4>Web & App Development</h4>
        <p>
          Custom applications built to federal standards, ensuring accessibility and security.
        </p>
        <a href="/services" className="federal-service-link">Learn More</a>
      </div>

      <div className="federal-service-card">
        <div className="federal-icon-box">
          <FiCpu />
        </div>
        <h4>AI & Automation</h4>
        <p>
          Intelligent automation solutions to optimize government operations and compliance.
        </p>
        <a href="/services" className="federal-service-link">Learn More</a>
      </div>
    </div>
  </div>
</section>


 

   {/* Industries Section */}
<section className="industries section">
  <div className="industries-wrapper">

    {/* LEFT CONTENT */}
    <div className="industries-content">
      <h2 className="section-title">Industries We Empower</h2>
      <p className="industries-desc">
        We deliver tailored technology, consulting, and digital transformation
        solutions across diverse industries. Our expertise helps organizations
        improve efficiency, enhance security, and achieve sustainable growth.
      </p>
      
<p className="industries-desc">
  By leveraging innovative tools and industry best practices, we empower
  businesses to stay ahead of evolving market demands. From strategy to
  implementation, InfraMart Solutions ensures seamless integration of
  technology to drive measurable results.
</p>
    </div>

    {/* RIGHT TILES */}
    <div className="industries-grid tiles">
      <div className="industry-tile">
        <i className="fas fa-landmark"></i>
        <h4>Government & Public Sector</h4>
      </div>

      <div className="industry-tile">
        <i className="fas fa-hospital"></i>
        <h4>Healthcare</h4>
      </div>

      <div className="industry-tile">
        <i className="fas fa-university"></i>
        <h4>Finance & Banking</h4>
      </div>

      <div className="industry-tile">
        <i className="fas fa-graduation-cap"></i>
        <h4>Education</h4>
      </div>

      <div className="industry-tile">
        <i className="fas fa-shopping-cart"></i>
        <h4>Retail & E-Commerce</h4>
      </div>

      <div className="industry-tile">
        <i className="fas fa-laptop-code"></i>
        <h4>Technology & SaaS</h4>
      </div>
    </div>

  </div>
</section>

  
  <section className="contact-sec">
      <div className="contact-sec-container">
        {/* LEFT IMAGE */}
        <div ref={imgRef} className="contact-sec-image">
          <img src={contactImg} alt="Contact" />
        </div>

        {/* RIGHT FORM */}
        <div ref={formRef} className="contact-sec-form-wrapper">
          <form className="contact-sec-form">
            <h2>Contact Us</h2>
            <input type="text" name="fullName" placeholder="Full Name" required />
            <input type="email" name="email" placeholder="Email Address" required />
            <input type="text" name="contact" placeholder="Contact Number" />
            <textarea name="message" placeholder="Your Message" rows="4" required />
            <button type="submit" className="contact-sec-btn">Submit</button>
          </form>
        </div>
      </div>
    </section>
 
  







         

         <section className="testimonials-wrapper">
      <div className="testimonials-container">
        <h2>Trusted by Global Clients</h2>
        <p className="sub-text">
          Businesses worldwide rely on Inframart Solutions for secure and scalable IT services.
        </p>

        <div className="testimonials-grid">
          {testimonials.map((item, index) => (
            <div className="testimonial-card" key={index}>
              <p className="comment">
              <span className="quote">“</span>
              {item.comment}
             <span className="quote">”</span>
             </p>

               <h4>{item.name}</h4>

               <span className="country-badge">{item.country}</span>

             </div>
          ))}
        </div>
      </div>
    </section>


    
      
  



  





      
   
    
 


  
     {/* Why Choose Us Section */}
   


     <section className="cta">
  

  {/* New Description inside same blue background */}
  <div className="cta-description">
    <h3 className="cta-desc-heading">Let us together build a flourishing business</h3>
    <p className="cta-desc-text">
      When connected with us, you aren’t growing your business alone. We have your back and put in our best to contribute to the growth of your entire team and organization. So, if you are looking for the right agency that’ll help you build a good online presence and bring in more conversions and revenue, we are right here!
    </p>
    
  </div>
  <div className="trusted-imag">
    <img src={require("../assets/girl.jpg")} alt="Trusted 1" />
    <img src={require("../assets/22.jpg")} alt="Trusted 2" />
    <img src={require("../assets/blak.jpg")} alt="Trusted 3" />
    <img src={require("../assets/11.jpg")} alt="Trusted 3" />

    
  </div>
  
</section>





    </>
  );
};

export default Section;
